import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "mb-1" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-x-4 mt-6" }
const _hoisted_3 = { class: "flex flex-col gap-4" }
const _hoisted_4 = { class: "w-full mt-2" }
const _hoisted_5 = { class: "grid grid-cols-3 gap-x-2 mt-2" }
const _hoisted_6 = { class: "flex flex-row items-center" }
const _hoisted_7 = { class: "flex flex-row items-center gap-x-4 pb-2" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = {
  key: 0,
  class: "text-red-lp-100 text-14px xxl:text-16px flex mt-2 pl-1 gap-x-2"
}
const _hoisted_11 = {
  key: 0,
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Foto pendukung wajib diupload. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      fontSize: "20",
      label: _ctx.$t('bookingShipment.column.additionalInformation'),
      fontColor: "text-gray-lp-300",
      hint: _ctx.productName === 'INTERPACKMAXI' ? _ctx.$t('bookingShipment.column.additionalInterpackMaxi') : _ctx.$t('bookingShipment.column.additionalInterpack')
    }, null, 8, ["label", "hint"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('revamp.booking.detailCommodity'),
        tooltipTitle: _ctx.$t('bookingShipment.tooltip.detailCommodity'),
        tooltipDescription: _ctx.$t('bookingShipment.tooltip.detailCommodityMsg'),
        fontSize: 14,
        optional: !_ctx.internationalDocumentDetail.commodity
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lp_input, {
            id: "text_area_detail_komoditas_interpack_create_booking",
            type: "textarea",
            modelValue: _ctx.modelValue.commodity,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.commodity = $event)),
            placeholder: _ctx.$t('bookingShipment.placeholder.commodityDetails'),
            format: _ctx.replaceNewLine,
            maxLength: 1000,
            showMaxLength: true,
            onChange: _ctx.validateCommodity,
            error: _ctx.error.commodity || _ctx.errorCommodityMandatory,
            errorCaption: _ctx.$t('bookingShipment.error.detailCommodity'),
            textAreaRows: 8,
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFieldIndex(_ctx.indexErrorCommodity)))
          }, null, 8, ["modelValue", "placeholder", "format", "onChange", "error", "errorCaption"])
        ]),
        _: 1
      }, 8, ["label", "tooltipTitle", "tooltipDescription", "optional"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          label: "Email",
          fontSize: 14,
          tooltipTitle: " ",
          tooltipDescription: " ",
          optional: !_ctx.internationalDocumentDetail.email
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              id: "input_email_interpack_create_booking",
              type: "email",
              placeholder: _ctx.$t('bookingShipment.placeholder.email'),
              modelValue: _ctx.modelValue.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.email = $event)),
              error: _ctx.error.email || _ctx.errorEmailMandatory,
              errorCaption: _ctx.errorEmailCaption,
              onChange: _ctx.validateEmail,
              onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setFieldIndex(_ctx.indexErrorEmail)))
            }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange"])
          ]),
          _: 1
        }, 8, ["optional"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('revamp.booking.recipientIdNumber'),
          fontSize: 14,
          optional: !_ctx.internationalDocumentDetail.idcIsIdentityNumber
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              id: "input_nomor_id_penerima_interpack_create_booking",
              type: "text",
              maxLength: 100,
              placeholder: _ctx.$t('bookingShipment.placeholder.sttIdentityNumber'),
              modelValue: _ctx.modelValue.sttIdentityNumber,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.sttIdentityNumber = $event)),
              error: _ctx.error.sttIdentityNumber || _ctx.errorSttIdentityNumberMandatory,
              errorCaption: 
              _ctx.$t('bookingShipment.error.sttIdentityNumberRequired')
            ,
              onChange: _ctx.validateIdentityNumber,
              onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setFieldIndex(_ctx.indexErrorSttIdentityNumber)))
            }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange"])
          ]),
          _: 1
        }, 8, ["label", "optional"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('revamp.booking.recipientTaxIdNumber'),
          fontSize: 14,
          optional: !_ctx.internationalDocumentDetail.idcIsTaxIdentificationNumber
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              id: "input_nomor_tax_id_penerima_interpack_create_booking",
              type: "text",
              maxLength: 100,
              placeholder: _ctx.$t('bookingShipment.placeholder.sttInterTaxNumber'),
              modelValue: _ctx.modelValue.sttInterTaxNumber,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.sttInterTaxNumber = $event)),
              error: _ctx.error.sttInterTaxNumber || _ctx.errorSttInterTaxNumberMandatory,
              errorCaption: 
              _ctx.$t('bookingShipment.error.sttInterTaxNumberRequired')
            ,
              onChange: _ctx.validateInterTaxNumber,
              onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setFieldIndex(_ctx.indexErrorSttInterTaxNumber)))
            }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange"])
          ]),
          _: 1
        }, 8, ["label", "optional"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('revamp.booking.additionalPhoto'),
        fontSize: 14
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_card, { class: "p-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_Title, {
                  fontSize: "14",
                  label: _ctx.$t('revamp.booking.beforeAndAfterPackingPhoto'),
                  fontColor: "text-gray-lp-300",
                  hint: !_ctx.internationalDocumentDetail.afterPacking ? '(Opsional)' : ''
                }, null, 8, ["label", "hint"]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        (index < 2)
                          ? (_openBlock(), _createBlock(_component_UploadImageTiny, {
                              key: 0,
                              id: 
                      index === 0
                        ? 'input_file_foto_sebelum_interpack_create_booking'
                        : 'input_file_foto_sesudah_interpack_create_booking'
                    ,
                              widthImage: "w-full",
                              accept: "image/jpg, image/jpeg",
                              title: photo,
                              modelValue: _ctx.attachmentImage[index],
                              "onUpdate:modelValue": ($event: any) => (_ctx.attachmentImage[index] = $event),
                              defaultImage: _ctx.storageImages[index],
                              maxSize: 5,
                              multipleIndex: index,
                              onUpload: _ctx.upload,
                              onRemove: _ctx.remove
                            }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue", "defaultImage", "multipleIndex", "onUpload", "onRemove"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_card, { class: "p-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_Title, {
                  fontSize: "14",
                  label: _ctx.$t('revamp.booking.recipientIdPhoto'),
                  fontColor: "text-gray-lp-300",
                  hint: !_ctx.internationalDocumentDetail.ktp ? '(Opsional)' : ''
                }, null, 8, ["label", "hint"]),
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_UploadImageTiny, {
                    id: "input_file_foto_id_penerima_interpack_create_booking",
                    accept: "image/jpg, image/jpeg",
                    title: _ctx.proofPhotos[2],
                    modelValue: _ctx.attachmentImage[2],
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.attachmentImage[2] = $event)),
                    defaultImage: _ctx.storageImages[2],
                    maxSize: 5,
                    multipleIndex: 2,
                    onUpload: _ctx.upload,
                    onRemove: _ctx.remove
                  }, null, 8, ["title", "modelValue", "defaultImage", "onUpload", "onRemove"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_card, { class: "p-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_Title, {
                  fontSize: "14",
                  label: _ctx.$t('revamp.booking.recipientTaxIdPhoto'),
                  fontColor: "text-gray-lp-300",
                  hint: !_ctx.internationalDocumentDetail.npwp ? '(Opsional)' : ''
                }, null, 8, ["label", "hint"]),
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_UploadImageTiny, {
                    id: "input_file_foto_tax_id_penerima_interpack_create_booking",
                    accept: "image/jpg, image/jpeg",
                    title: _ctx.proofPhotos[3],
                    modelValue: _ctx.attachmentImage[3],
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.attachmentImage[3] = $event)),
                    defaultImage: _ctx.storageImages[3],
                    maxSize: 5,
                    multipleIndex: 3,
                    onUpload: _ctx.upload,
                    onRemove: _ctx.remove
                  }, null, 8, ["title", "modelValue", "defaultImage", "onUpload", "onRemove"])
                ])
              ]),
              _: 1
            })
          ]),
          (_ctx.isErrorFile && _ctx.mandatoryUploadFile)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                (_ctx.isErrorFile && _ctx.mandatoryUploadFile)
                  ? (_openBlock(), _createBlock("img", _hoisted_11))
                  : _createCommentVNode("", true),
                _hoisted_12
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ]))
}